import { AuthManagerBase } from "./managerBase";
import { ConferenceManager } from "./conferenceManager";
import { HeimdallManager } from "./heimdallManager";
import { ApolloClient } from "@apollo/client";
import { TStore } from "../types";

export const createManager = (apolloClient: ApolloClient<any>, store: TStore): AuthManagerBase => {
    const manager = ConferenceManager.getToken() ? ConferenceManager : HeimdallManager;
    return new manager(apolloClient, store);
};
